import { render } from "./QuestionAnswer.vue?vue&type=template&id=18c5ee5e&scoped=true&ts=true"
import script from "./QuestionAnswer.vue?vue&type=script&lang=ts"
export * from "./QuestionAnswer.vue?vue&type=script&lang=ts"

import "./QuestionAnswer.vue?vue&type=style&index=0&id=18c5ee5e&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c5ee5e"]])

export default __exports__